import { render, staticRenderFns } from "./TinElorus.vue?vue&type=template&id=5a4af06a"
import script from "./TinElorus.vue?vue&type=script&lang=js"
export * from "./TinElorus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports